import { useCallback, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faPlusCircle, faTrophy } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

import { AppHeader } from "../../components/header/header";
import { LoadingIndicator } from "../../components/utilities/loader";
import { useAuth } from "../../services/authentication/authentication.context";
import { useLesson } from "../../services/lessons/lessons.context";
import { formatUrl } from "../../_helpers/parseurl";
import { AppAlert } from "../../components/utilities/app-alert";
import { QuestionUnit } from "../../components/courses/question-unit";
import { AppFooter } from "../../components/footer/footer";


export const CoursePage = () => {

    const { isLoading, isAdmin, token, markAsComplete, user } = useAuth();
    const { getLessonsByCategory } = useLesson();

    const [lessons, setLessons] = useState([]);
    const [current, setCurrent] = useState();
    const [onAlert, setOnAlert] = useState();
    const [eQuestions, setEQuestions] = useState();
    const [answers, setAnswers] = useState({});
    const [submited, setSubmited] = useState(false);
    const [correctAns, setCorrectAns] = useState();
    const [slide, setSlide] = useState();



    const navigateTo = useNavigate();

    const course = useLocation()?.state?.course;
    const fieldId = course?._id

    const letterOpttions = ['A', 'B', 'C', 'D'];

    const getFieldLesson = useCallback(() => {
        (async () => {
            const resp = await getLessonsByCategory(fieldId);
            if (resp?.error) {
                return setLessons[''];
            }
            setLessons(resp);
        })();
        return () => { console.log("") }
    }, [fieldId, getLessonsByCategory])


    useEffect(() => {
        getFieldLesson();
        setEQuestions(current?.questions?.questions);
        const answerArray = Object.values(answers);

        const correctanswers = answerArray.filter((answ, indx) => {
            return answ === eQuestions[indx].answer;
        }).length;
        setCorrectAns(correctanswers);
        //console.log({id: current?.questions._id})
    }, [getFieldLesson, current, answers, user, eQuestions]);

    /** check if lesson is validated */
    const isValidated = (lessonId) => {
        const thisCourse = user?.courses.find((course) => (course?.course.toString() === fieldId.toString()))
        const lessons = thisCourse?.lessons;
        // console.log({course: user?.courses, fieldId, thisCourse,lessons})
        if (!lessons) return false;
        const found = lessons?.includes(lessonId);
        return found ? true : false;
    }



    return (
        <div className={classNames("flx-v")}>
            <AppHeader />
            {isLoading && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onAccept={onAlert.onAccept}
                    closeAlert={() => setOnAlert()}
                    onReject={() => setOnAlert()}
                />
            )}
            <div className="list-slider">
                <button
                    className={classNames("slider-button")}
                    onClick={() => setSlide((s) => !s)}
                >
                    <FontAwesomeIcon
                        icon={faChevronLeft}
                        className={classNames("norm", { "rot": slide })}
                    />
                </button>
            </div>
            <div className="lesson-page">

                <div className="lesson-video">
                    {current ?
                        <video
                            className="current-vid"
                            controls={true}
                            src={formatUrl(current?.video) || formatUrl(lessons[0]?.video)}
                        /> :
                        <div className={classNames("start-page", "flx-cnt-pg")}>
                            <div className="course-data">
                                <div className="course-poster">
                                    <img
                                        className="poster-img"
                                        alt=""
                                        src={formatUrl(course?.poster)}
                                        loading="lazy"
                                    />
                                </div>
                                <div className={classNames("course-caption", 'v-4')}>{course?.title}</div>
                                <div className="course-det">{course?.slogan}</div>
                            </div>
                            <button className="start-button" onClick={() => setCurrent(lessons[0])}>
                                Get Started
                            </button>
                            <div className="md-sp" />
                        </div>
                    }
                </div>
                {lessons.length === 0 ?
                    <div className={classNames("lesson-list", { "slide": slide })}>

                    </div> :
                    <div className={classNames("lesson-list", { "slide": slide })}>
                        {lessons?.map((lesson, i) => (
                            <div
                                className={classNames("unit-box", { 'col': isAdmin })}
                                key={i}
                            >
                                <div
                                    className={classNames(
                                        "lesson-list-unit",
                                        { "selected": current?._id === lesson?._id }
                                    )}
                                    onClick={() => setCurrent(lesson)}
                                >
                                    <span
                                        className={classNames(
                                            "lesson-t",
                                            { "selected": current?._id === lesson?._id }
                                        )
                                        }
                                    >
                                        {lesson.title}
                                    </span>
                                    <a
                                        href={formatUrl(lesson.document)}
                                        download={true}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="resource-link"
                                    >
                                        Resources
                                    </a>
                                    {isValidated(lesson._id) && (
                                        <FontAwesomeIcon icon={faTrophy} className="trophy" />
                                    )}
                                </div>
                                {isAdmin && (
                                    <button
                                        className="lesson-edit"
                                        onClick={() => {
                                            setOnAlert({
                                                caption: "Add/Edit Evaluation",
                                                message: "Do you wish to add or update the assesment questions for this lesson?",
                                                accept: "Proceed",
                                                reject: "Cancel",
                                                onAccept: async () => {
                                                    navigateTo("/createval", { state: { id: lesson.questions } })
                                                }
                                            })
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faPlusCircle} />
                                    </button>
                                )}

                            </div>
                        ))}
                    </div>
                }
            </div>
            <div className="eval-prev">
                {(current && submited) && (
                    <div className="score-panel">
                        <div
                            className={
                                classNames(
                                    'score',
                                    { 'failed': correctAns < 0.9 * eQuestions.length }
                                )
                            }
                        >
                            {correctAns} / {eQuestions?.length}
                        </div>
                        {(correctAns < 0.9 * eQuestions.length) && (
                            <div className="hr-sp-3">
                                <div className="failed">Oops! you have scored less than 90%.</div>
                                <div className="failed">You have to score higher to validate this course!</div>
                            </div>
                        )}

                        {(correctAns < 0.9 * eQuestions.length) &&
                            <button
                                className="retake-btn"
                                onClick={() => {
                                    setAnswers({});
                                    setCorrectAns();
                                    setSubmited(false);
                                }}
                            >
                                Retake this test
                            </button>}
                    </div>
                )}
                {eQuestions?.map((q, i) => {
                    return (
                        <QuestionUnit
                            questionData={q}
                            indx={i}
                            addAnswer={(k) => setAnswers((answ) => ({ ...answ, [i]: letterOpttions[k] }))}
                            isCorrect={answers[i] === eQuestions[i].answer}
                            key={i}
                            submited={submited}
                            cancel={Object.keys(answers).length === 0}
                            isSuperAdmin={isAdmin}
                            questionsId={current?.questions._id}
                        />
                    )
                })}
                {current &&
                    <button
                        className={classNames("form-button", 'pill-input-box')}
                        onClick={async () => {
                            setSubmited(true)
                            if (correctAns > 0.9 * eQuestions.length) {
                                let data = ({
                                    lessonId: current?._id,
                                    courseId: fieldId
                                });

                                const res = await markAsComplete(data, token);
                                setOnAlert({
                                    caption: res.caption,
                                    message: res.message,
                                    accept: "Ok",
                                    onAccept: () => setOnAlert()
                                })
                            }
                        }}
                    >
                        Submit
                    </button>
                }
            </div>
            <AppFooter />
        </div>
    )
}